function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M13.5977,5.4023 L10.3127,8.0303 C10.1297,8.1763 9.8697,8.1763 9.6877,8.0303 L6.4027,5.4023 C6.2207,5.2573 5.9637,5.2563 5.7817,5.3993 L-0.0003,9.9223 L-0.0003,12.0003 C-0.0003,13.1043 0.8957,14.0003 1.9997,14.0003 L17.9997,14.0003 C19.1047,14.0003 19.9997,13.1043 19.9997,12.0003 L19.9997,9.9223 L14.2187,5.3993 C14.0357,5.2563 13.7797,5.2573 13.5977,5.4023 Z M19.9997,2.0003 C19.9997,1.4933 19.8057,1.0363 19.4947,0.6843 L16.0047,3.4763 C15.7527,3.6783 15.7547,4.0623 16.0097,4.2603 L19.9997,7.3833 L19.9997,2.0003 Z M17.1497,0.0003 L2.8507,0.0003 L9.6877,5.4693 C9.8697,5.6153 10.1297,5.6153 10.3127,5.4693 L17.1497,0.0003 Z M-0.0003,7.3833 L-0.0003,2.0003 C-0.0003,1.4933 0.1947,1.0363 0.5047,0.6843 L3.9947,3.4763 C4.2467,3.6783 4.2447,4.0623 3.9907,4.2603 L-0.0003,7.3833 Z",
  id: "path-1"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 -3 20 20"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/email.a2bc7222.svg";
export { SvgComponent as ReactComponent };